<template>
  <div id="app">
    <div id="shownOnceAuthed">

      <b-navbar toggleable="md" fixed="top">
        <b-navbar-brand item>
          <router-link to="/">
            <img height="28px" class="logo" src="./assets/images/logo_rg-new.png">
          </router-link>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse" v-if="isAuthenticated"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="navbar-main" v-show="shouldShowNav">
            <router-link is="b-nav-item" to="/bold-dashboard" v-if="isAuthenticated && userPermissions.viewDashboard">
              <img width="25" height="25" src="./assets/images/icon_light-Dashboard.png">Dashboard</router-link>
            <router-link is="b-nav-item" to="/dashboard" class="d-none" v-if="isAuthenticated">Dashboard</router-link>
            <router-link is="b-nav-item" v-if="isAuthenticated && userPermissions.manageEvents" to="/events">
              <img width="25" height="25" src="./assets/images/icon_light-Events.png">Events</router-link>
            <router-link is="b-nav-item" v-if="isAuthenticated && userPermissions.viewCorrespondence" to="/correspondence">
              <img width="25" height="25" src="./assets/images/icon_light-Events.png">Correspondence</router-link>
            <router-link is="b-nav-item" to="/routinetasks"
              v-if="isAuthenticated && userPermissions.manageProcedures && !this.isBlueRidgeOrMadisonCommunities">
              <img width="25" height="25" src="./assets/images/icon_light-Tasks.png">Tasks</router-link>
            <b-nav-item-dropdown v-if="isAuthenticated" item text="Procedures" dropright simple>
              <template slot="button-content">
                <img width="25" height="25" src="./assets/images/icon_light-Procedures.png">
                <span>Procedures</span>
              </template>
              <router-link is="b-dropdown-item" :to="{ path:'/procedures/1', params:{currentView: 1}}"
                v-if="isAuthenticated && userPermissions.manageProcedures">Incidents</router-link>
              <router-link is="b-dropdown-item" :to="{ path:'/procedures/2', params:{currentView: 2}}"
                v-if="isAuthenticated && userPermissions.manageProcedures && !this.isBlueRidgeOrMadisonCommunities">Tasks
                / Inspections</router-link>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown v-if="isAuthenticated && (userPermissions.manageCompanyProfile || userPermissions.manageRoles || userPermissions.manageUsers || userPermissions.manageProperties ||
                 userPermissions.manageVendors || userPermissions.manageVendorTypes || userPermissions.manageEventCategories||
                  userPermissions.managePropertyGroups || userPermissions.manageNotificationTemplates || userPermissions.manageCompanies || isRgAdmin)" item text="Setup" dropright simple>
              <template slot="button-content">
                <img width="25" height="25" src="./assets/images/icon_light-Setup.png">
                <span>Setup</span>
              </template>
              <router-link is="b-dropdown-item" to="/company"
                v-if="isAuthenticated && userPermissions.manageCompanyProfile">Company Details</router-link>
              <router-link is="b-dropdown-item" to="/positionTypes"
                v-if="isAuthenticated && userPermissions.manageRoles">Roles</router-link>
              <router-link is="b-dropdown-item" to="/setup/people"
                v-if="isAuthenticated && userPermissions.manageUsers">Users</router-link>
              <router-link is="b-dropdown-item" to="/properties"
                v-if="isAuthenticated && userPermissions.manageProperties">Properties</router-link>
              <router-link is="b-dropdown-item" to="/vendors"
                v-if="isAuthenticated && userPermissions.manageVendors">Vendors</router-link>
              <router-link is="b-dropdown-item" to="/vendorTypes"
                v-if="isAuthenticated && userPermissions.manageVendorTypes">Vendor Types</router-link>
              <router-link is="b-dropdown-item" to="/setup/categories"
                v-if="isAuthenticated && userPermissions.manageEventCategories">Event Categories</router-link>
              <router-link is="b-dropdown-item" to="/setup/documentTypes"
                v-if="isAuthenticated && userPermissions.manageEventCategories">Document Types</router-link>
              <router-link is="b-dropdown-item" to="/setup/propertyGroups"
                v-if="isAuthenticated && userPermissions.managePropertyGroups">Property Groups</router-link>
              <router-link is="b-dropdown-item" to="/setup/notification-templates"
                v-if="isAuthenticated && userPermissions.manageNotificationTemplates && isFeatureEnabled('permission.manage-notification-templates')">Notification Templates</router-link>
              <router-link is="b-dropdown-item" to="/setup/feature-flags"
                v-if="isAuthenticated && isRgAdmin">Feature Flags</router-link>
              <router-link is="b-dropdown-item" to="/admin/companies"
                v-if="isAuthenticated && userPermissions.manageCompanies && isFeatureEnabled('permission.manage-companies')">Companies</router-link>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown v-if="isAuthenticated" item text="Setup" dropright simple>
              <template slot="button-content">
                <img width="25" height="25" src="./assets/images/icon_light-Reports.png">
                <span>Reports</span>
              </template>
              <router-link is="b-dropdown-item" to="/reports/propertyEventTypeCount"
                v-if="isAuthenticated && userPermissions.manageProperties">Event Counts</router-link>
              <!-- DEPRECATED as of 1/12/2026: This menu link should probably be removed entirely.
                   The Insurance Claim data model has changed significantly with deprecated fields removed
                   and new auto-calculated financial fields added. This report uses the old data model.
              <router-link is="b-dropdown-item" to="/reports/insuranceClaims"
                v-if="isAuthenticated && userPermissions.manageProperties">Insurance Claims</router-link>
              -->
            </b-nav-item-dropdown>
            <router-link is="b-nav-item" to="/resources"
              v-if="isAuthenticated /*May need additional permissions here for managing resources*/">
              <img width="25" height="25" src="./assets/images/icon_light-Resources.png">
              Resources</router-link>
            <b-nav-item-dropdown v-if="isAuthenticated && userPermissions.manageInsurancePolicies" dropright simple>
              <template slot="button-content">
                <img width="25" height="25" src="./assets/images/icon_light-Policies.png">
                <span>Insurance</span>
              </template>
              <router-link is="b-dropdown-item" to="/insurancepolicies">Policies</router-link>
              <router-link is="b-dropdown-item" to="/policycontainers">Policy Containers</router-link>
            </b-nav-item-dropdown>
            <router-link is="b-nav-item" to="/import-export"
              v-if="isAuthenticated && userPermissions.manageImportExport && isFeatureEnabled('permission.manage-import-export')">
              <img width="25" height="25" src="./assets/images/icon_light-Import.png">
                Import/Export</router-link>
            <router-link is="b-nav-item" to="/notifications"
              v-if="isAuthenticated && userPermissions.manageSubscriptions">
              <img width="25" height="25" src="./assets/images/icon_light-Subscriptions.png">
              Subscriptions</router-link>

          </b-navbar-nav>
          <b-navbar-nav position="right" class="ml-auto navbar-right">
            <router-link is="b-nav-item" title="Company"
              v-if="isAuthenticated && this.$store.state.userCurrentCompany && shouldShowNav" to="/company"
              class="d-md-block d-none">
              <span class="text-truncate">{{this.$store.state.userCurrentCompany.companyName}}</span>
              </router-link>
            <router-link is="b-nav-item" v-if="isAuthenticated && shouldShowNav" to="/profile" title="Profile">
              <img width="25" height="25" src="./assets/images/icon_light-Profile.png">
                <span class="">Profile</span></router-link>
            <li class="nav-item" v-if="isAuthenticated && shouldShowNav">
              <a class="nav-link" href="mailto:support@responsegrid.net" title="Email Support">
                <img width="25" height="25" src="./assets/images/icon_light-Contact.png">
                  <span class="d-md-none d-inline">support@responsegrid.net</span>
                  <span class="d-md-inline d-none">Contact</span>
                </a>
            </li>
            <!-- <li class="nav-item" v-if="isAuthenticated && shouldShowNav && isChatEnabled">
              <a href="#" class="nav-link" title="AI Assistant" @click.prevent="toggleChat">
                <i class="ml-1 fa fa-comments" />
                <span class="ml-1 d-inline">AI Assistant</span>
              </a>
            </li> -->
            <li class="nav-item" v-if="isAuthenticated">
              <a href="#" @click.prevent="logout" class="bg-black-50 nav-link" title="logout">
                <img width="25" height="25" src="./assets/images/icon_light-logout.png">
                <span>Logout</span></a>
            </li>
          </b-navbar-nav>
          <div class="login-container" v-if="!isAuthenticated && !isPublicShareRoute">
            <div class="card d-flex flex-column align-items-center justify-content-center">
              <i class="fa fa-spinner fa-pulse fa-2x fa-fw text-white"></i>
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </b-collapse>
        <b-navbar-nav position="right" class="login-container d-md-none d-flex" v-if="!isAuthenticated && !isPublicShareRoute">
          <div class="card d-flex flex-column align-items-center justify-content-center">
            <i class="fa fa-spinner fa-pulse fa-2x fa-fw text-white"></i>
            <span class="sr-only">Loading...</span>
          </div>
        </b-navbar-nav>
      </b-navbar>

      <div>
        <router-view></router-view>
      </div>

      <ai-chat-panel v-if="isAuthenticated && isChatEnabled" />

      <div class="footer px-3">
        <div class="row no-gutters">
          <div class="col"></div>
          <div class="col-6 d-flex justify-content-center">
            <a href="./assets/docs/Response-Grid-Terms-of-Service-19.12311443.1.pdf" target="_blank">Terms <span
                class="d-md-inline d-none">&amp; Conditions</span></a>
          </div>
          <div class="col text-right text-white-50">
            &copy; {{currentYear}} <span class="d-md-inline d-none">Response Grid</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { isResponseGridAdmin } from '@/auth/responseGridAdmin'
import AiChatPanel from '@/components/AiChatPanel'

/*eslint-disable */
(function (apiKey) {
  (function (p, e, n, d, o) {
    var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || []
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w) {
      (function (m) {
        o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))) }
      })(v[w])
    }
    y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js'
    z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z)
  })(window, document, 'script', 'pendo')
})(process.env.PENDO_API_KEY)
/* eslint-enable */
export default {
  name: 'App',
  components: { AiChatPanel },
  data () {
    return {
    //  isAuthenticated: false
      currentYear: moment().format('YYYY')
    }
  },
  async created () {
    try {

    } catch (e) {
      console.log(e)
    }
  },
  async mounted () {
    // ... existing code ...
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    },
    isAuthLoading () {
      return this.$auth.loading
    },
    userPermissions () {
      return this.$store.state.loggedInUserPermissions
    },
    isAuthenticated () {
      return this.$auth.isAuthenticated
    },
    isRgAdmin () {
      return this.$auth.user && isResponseGridAdmin(this.$auth.user.email)
    },
    isFeatureEnabled () {
      return this.$store.getters['featureFlags/isEnabled']
    },
    shouldShowNav () {
      return this.isAuthenticated && !this.$route.path.startsWith('/share/')
    },
    isPublicShareRoute () {
      return this.$route.path.startsWith('/share/')
    },
    isBlueRidgeOrMadisonCommunities () {
      return (this.$store.state.userCurrentCompany.companyName === 'Blue Ridge Companies')
    },
    isChatEnabled () {
      return this.isFeatureEnabled('ai.chat') && this.userPermissions.useAiChat
    }
  },
  methods: {
    login () {
      this.$auth.loginWithRedirect()
    },
    logout () {
      this.$auth.logout({
        returnTo: window.location.origin
      })
    },
    toggleChat () {
      this.$store.dispatch('chatbot/toggle')
    }
  }
}

</script>

<style>
/*Base*/
html {
  font-size: .85em;
  height: 100%;
}
body{
  padding-top: 0px !important;
  padding-left: 180px !important;
  background-color: #f1f1f1 !important;
  height: 100%;
}

body:has(.hide-overflow){
    overflow: hidden !important;
}
@media screen and (max-width: 767px){
  body{
    padding-left: 0px !important;
    font-size: 1rem;
    padding-top: 60px !important;
  }
}
.fixed-top {
  z-index: 1000 !important;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.main.container {
  margin-top: 2em;
}
.ui.modals.active .modal{
  position: relative;
}
label {
  font-weight: 500;
  margin-bottom: 0em !important;
  font-size: 85%;
}
.btn {
  border-radius: .25em !important;
  line-height: 1.4;
}
.btn:hover {
  cursor: pointer;
}
.btn-group .btn:only-child {
  border-radius: 2em !important;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle), .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.btn-group > .btn:not(:first-child), .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.btn-group.btn-group-filter > .btn-light {
  border-radius: 0;
  background-color: transparent;
  border-color: rgba(0,0,0,0.08);
  box-shadow: 0 1px 0 #fff;
}
.btn-group.btn-group-filter .btn-light:hover {
  background: rgba(255,255,255,0.5) !important;
  box-shadow: 0 1px 0 #fff, inset 1px 0 2px rgba(0,0,0,0.1);
}
.btn-group.btn-group-filter .btn-light.active,
.btn-group.btn-group-filter .btn-light.active:hover {
  background-color: #fff !important;
  color: #000 !important;
  border-color: rgba(0,0,0,0.2);
  box-shadow: 0 0 5px rgba(0,0,0,0.15);
}
.btn.rounded-0 {
  border-radius: 0 !important;
}
.input-group-append .btn {
  border-radius: 0 .3em .3em 0 !important;
}
.input-group-prepend .btn {
  border-radius: .3em 0 0 .3em !important;
}
.validation {
  color: #cf3838;
  font-size: 85%;
}
.section-label {
  font-size: 90%;
  font-weight: 500;
  margin-bottom: 1em;
  text-transform: uppercase;
  color: #37a3dc;
  font-weight: bold;
}
.card {
  border-radius: 1em;
}

/*Brand Colors*/
.brand-light-blue {
  color: #74c5ef;
}

.brand-blue {
  color: #3fa4d8;
}

.brand-aqua {
  color: #6db78c;
}

.brand-green {
  color: #97c84a;
}

.brand-dark-blue-bg {
  background-color: #13385a;
}

/*Transparent Colors*/
.bg-white-10 {
  background: rgba(255, 255, 255, 0.1);
}

.bg-white-25 {
  background: rgba(255, 255, 255, 0.25);
}

.bg-white-50 {
  background: rgba(255, 255, 255, 0.50);
}

.bg-black-10 {
  background: rgba(0, 0, 0, 0.1);
}

.bg-black-25 {
  background: rgba(0, 0, 0, 0.25);
}

.bg-black-50 {
  background: rgba(0, 0, 0, 0.50);
}

/*Navigation*/
.navbar{
  padding: 0;
  background: #0c2032 !important;
  display: flex;
  flex-direction: column !important;
  width: 180px;
  height: 100%;
}
.navbar-nav .nav-link {
  padding: 1.1rem .8rem !important;
  font-size: 95%;
  font-weight: 500;
  color: rgba(255,255,255,0.7);
}
.navbar-nav .nav-link i{
  line-height: 1;
}
.navbar-nav .nav-link.router-link-active,
.navbar-nav .nav-link.router-link-active:focus {
  color: #333 !important;
  opacity: 1;
  background: #efefef;
}
.navbar-nav.navbar-main .nav-link.router-link-active,
.navbar-nav.navbar-main .nav-link.router-link-active:hover{
  background: rgb(55, 163, 220);
  box-shadow: none !important;
  color: #fff !important;
}
.navbar-nav .nav-link:hover {
  background: rgba(255,255,255,0.05);
}
.navbar-toggler {
  border: none !important;
  position: relative;
  height: 40px;
}
@media screen and (min-width: 768px){
  .navbar-nav {
    left: 0;
    top: 50px;
    bottom: 0;
    width: 180px;
    height: 100%;
    flex-direction: column !important;
    z-index: 10;
  }
  .navbar-brand {
    padding: 1em;
    margin: 0;
  }
  .navbar-nav.navbar-right {
    position: relative;
    top: 0;
    width: auto;
    flex-direction: column !important;
    background: transparent !important;
    box-shadow: none;
    margin-left: 0;
    width: 180px;
    height: auto;
    padding-bottom: 4em;
    border-top: 1px solid rgba(255,255,255,0.15);
  }
  .navbar-nav.navbar-right .nav-link,
  .navbar-nav.navbar-right .nav-link:hover {
    color: #fff !important;
    display: flex;
    align-items: center;
  }
  .navbar-nav.navbar-right .nav-link.router-link-active,
  .navbar-nav.navbar-right .nav-link.router-link-active i,
  .navbar-nav.navbar-right .nav-link.router-link-active:focus {
    color: #fff !important;
    opacity: 1;
    background: rgba(255,255,255,0.1);
  }
  .navbar-nav.navbar-main .nav-item > a,
  .navbar-nav.navbar-right .nav-item > a{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 95%;
    line-height: 2;
    line-height: 2.5;
    justify-content: start;
    padding: 0.5em 0.75em !important;
    color: #fff;
    gap: 0.5em;
  }
  .navbar-nav.navbar-main .nav-item > a:hover{
    background: rgba(0,0,0,0.2);
    color: #fff;
    cursor: pointer;
  }
  .navbar-nav.navbar-main .nav-item > a:after{
    position: absolute;
    right: 20px;
    top: 25px;
  }
  .navbar-nav .nav-item:hover .dropdown-menu,
  .navbar-nav .nav-item.show:hover .dropdown-menu.show{
    display: block;
  }
  .navbar-nav .nav-item.show .dropdown-menu.show {
    display: none;
  }
  .navbar-nav .dropright .dropdown-menu {
    margin-left: 0;
    box-shadow: 1px 0px 8px rgba(0,0,0,0.25);
  }
  .navbar-expand-md .navbar-collapse {
    flex-direction: column !important;
  }
}

@media screen and (max-width: 767px){
  .navbar {
    height: 60px;
    flex-direction: row !important;
    width: 100%;
  }
  .navbar-toggler-icon {
    background-image: none !important;
    width: 30px !important;
    height: 2px !important;
    background: #fff !important;
  }
  .navbar-toggler-icon:after,
  .navbar-toggler-icon:before {
    content: "";
    display: block;
    width: 30px;
    height: 2px;
    background: #fff;
    position: absolute;
  }
  .navbar-toggler-icon:before {
    top: 12px;
  }
  .navbar-toggler-icon:after {
    bottom: 10px;
  }
  .navbar-nav .nav-link,
  .navbar-nav .dropdown-item {
    font-size: 130%;
    padding: 1em .75em !important;
    color: rgba(255, 255, 255, 0.75) !important;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 0.5em;
  }
  .navbar-nav .nav-link span,
  .navbar-nav .dropdown-item span{
    width: 100%;
  }
  .navbar-nav .nav-link i{
    display: none !important;
  }
  .navbar-nav .nav-link:hover,
  .navbar-nav .dropdown-item:hover {
    color: rgba(255, 255, 255, 1);
    background: rgba(255,255,255,0.05);
  }
  .navbar-nav .dropdown-menu {
    background: rgba(0,0,0,0.2);
    border: none;
  }
  .navbar-nav .nav-item.show .dropdown-toggle:after {
    transform: rotate(90deg);
  }
  .navbar {
    padding: 0 !important;
  }
  .navbar-brand {
    padding: 11px 0 12px 10px !important;
  }
  .navbar-right .nav-item:last-child{
    background: rgba(0,0,0,0.2);
  }
  .navbar-collapse {
    height: 100vh !important;
  }
  .navbar-collapse.collapsing {
        display: block;
        position: fixed;
        height: 100vh;
        top: 0;
        bottom: 0;
        left: -90%;
        transition: all 0.2s ease;
    }

    .navbar-collapse.show {
        position: fixed;
        height: 100vh;
        overflow: auto;
        top: 0;
        bottom: 0;
        left: 0;
        flex-direction: column;
        height: auto;
        width: 80%;
        transition: left 0.35s ease;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
        background-color: #061a2c;
        padding-bottom: 5em;
    }
}

/*Login*/
.login-container {
  position: fixed;
  left:0;right:0;top:0px;bottom:0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #13385a !important;
  background-image: url(./assets/images/img_rg-login-bg.jpg);
  background-size: cover;
}

.login-container .card {
  background-color: rgba(255,255,255,0.25);
  border-radius: 15px;
  width: 100px;
  height: 100px;
  box-shadow: 0 5px 30px rgba(0,0,0,0.25);
  border: none;
}

/*Footer*/
.footer {
  background-color: #1e2123;
  padding-top:2px;
  padding-bottom: 2px;
  font-size: 85%;
  position: fixed;
  bottom:0;
  left:0;
  right:0;
  z-index: 1050;
}
.footer .btn {
  border-radius: 15px 15px 0 0;
}

/*Table*/
td.table-action {
  padding: 2px !important;
}
td.table-action .button{
  background-color: transparent !important;
  color: #0a91da;
}
td.table-action .button:hover{
  color: #37a3dc;
}

/*Page*/
.page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);
  overflow: hidden;
}
.page-header {
  padding: 1em 0;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  overflow: hidden;
  position: relative;
  z-index: 0;
}

@media screen and (max-width: 767px) {
  .page {
    height: calc(100vh - 85px);
  }

  .page-header {
    overflow: visible;
  }
}

.page-header h3{
  color: #555 !important;
  display: flex;
  align-items: center;
  font-size: 115%;
  font-weight: 600;
  margin: 0;
}
/* .page-header h3 .icon,
.page-header h3 .fa{
  display: none;
} */
.page-header > div {
  position: relative;
  z-index: 1;
}
.icon-gradient {
  background: -webkit-linear-gradient(#37a3dc, #96c93d);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.page-header-shadow {
  overflow: visible;
}
.page-header-shadow:after {
  content: "";
  display: block;
  width: 100%;
  height: 15px;
  position: absolute;
  bottom: -15px;
  left: 0;
  background: -moz-linear-gradient(top, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%);
  background: -webkit-linear-gradient(top, rgba(0,0,0,0.4) 0%,rgba(0,0,0,0) 100%);
  background: linear-gradient(to bottom, rgba(0,0,0,0.4) 0%,rgba(0,0,0,0) 100%);
  opacity: 0.15;
}

/*RG Table*/
.rg-table.table {
  border-top: 1px solid #dee2e6;
  background-color: #ffffff;
}
.rg-table.table thead tr {
  box-shadow: 1px 0 5px rgba(0,0,0,0.15);
}
.rg-table.table thead tr th {
  font-size: 85%;
  padding-top: 1.5em;
  padding-bottom: 1.5em;
  border: none;
  background: #ffffff;
  color: #555;
  border-radius: 0 !important;
  position: sticky;
  top: 0;
  z-index: 2;
}
.rg-table.table thead tr th:after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 5px;
    background: -moz-linear-gradient(top, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%);
    background: -webkit-linear-gradient(top, rgba(0,0,0,0.4) 0%,rgba(0,0,0,0) 100%);
    background: linear-gradient(to bottom, rgba(0,0,0,0.4) 0%,rgba(0,0,0,0) 100%);
    opacity: 0.1;
}
.rg-table.table thead tr th .btn{
  position: absolute;
  right: -1px;
  top: -1px;
  border-radius: 0;
  box-shadow: -1px 0 0 0 rgba(255, 255, 255, 0.25);
}
/* .rg-table.table tbody tr:hover,
.rg-table.table tbody tr td.selectable:hover{
 cursor: pointer;
} */
.rg-table.table tbody tr td {
  vertical-align: middle;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.rg-table-add {
  background-color: #466379;
  padding: 5px;
  margin-bottom: -1px;
  border-radius: 4px 4px 0 0;
  z-index: 100;
  position: relative;
}
.rg-table-add .btn {
  border-radius: 0 2em 2em 0 !important;
}
.rg-table.text-condensed td {
  font-size: 85%;
}

@media only screen and (max-width: 767px) {
  .rg-table.table {
    border: none !important;
    background-color: transparent;
  }
  .rg-table.table thead {
    display: none !important;
  }
  .rg-table.table tbody tr {
    margin-bottom: 1em;
    border-radius: 4px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid rgba(0,0,0,0.15);
    position: relative;
    margin-bottom: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
    display: block;
    background-color: #fff;
  }
  .rg-table.table tbody tr td{
    border: none;
    display: block;
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 50px;
  }
  .rg-table.table tbody tr td .btn{
    border-radius: 0 !important;
  }
  .rg-table.table tbody tr td.table-action{
    padding: 0 !important;
  }
  .rg-table.table tr td.status,
  .rg-table.table tr td.actions{
    position: absolute;
    right: 0;
  }
  .rg-table.table tr td.status{
    top:0;
    background: #efefef;
    border-radius: 0 0 0 5px;
  }
  .rg-table.table tr td.actions{
    bottom:0
  }
  .rg-table.table tr td.emphasis,
  .rg-table.table tr td .emphasis {
    font-size: 120%;
    font-weight: 500;
  }
  td .btn {
    background: rgba(0, 0, 0, 0.03);
    width: 40px;
    height: 100%;
    border-radius: 0 4px 4px 0;
    margin-top: 0;
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: #007bff;
  }
  td .btn:nth-child(2) {
    right: 40px;
    border-left: 1px solid rgba(0,0,0,0.1);
  }
  .ui.modals.active {
    z-index: 2000;
    padding: 0 !important;
  }
  .ui.modal {
    width: 100%;
    height: 100% !important;
    display: flex !important;
    flex-direction: column;
    height: 100%;
  }
  .ui.modal > .header {
    padding-right: 1em !important;
  }
  .ui.modal .scrolling.content {
    max-height: none !important;
    flex-grow: 1 !important;
    height: calc(100% - 120px);
  }
}

@media screen and (min-width: 1400px) {
  .ui.container {
      width: 1300px;
      margin-left: auto!important;
      margin-right: auto!important;
  }
}

.dimmed.dimmable > .ui.animating.dimmer, .dimmed.dimmable > .ui.visible.dimmer, .ui.active.dimmer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ui.modal,
.ui.active.modal {
  margin: 0 auto!important;
  top: auto !important;
  left: auto !important;
  transform-origin: center !important;
  transition: all ease .3s;
  transition-delay: .4s;
}
.ui.modal.in{
  height: auto !important;
}
.card {
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgb(0 0 0 / 0%);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
}
.card-link:hover {
  text-decoration: none;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25) !important;
  -webkit-transform: scale(1.03);
  transform: scale(1.03);
}
.checkbox-list .custom-checkbox {
  padding-top: 0;
  padding-bottom: 0;
}
.checkbox-list .custom-checkbox:hover {
  background: rgba(0,0,0,0.05);
}
.checkbox-list .custom-checkbox label{
  width: 100%;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
}
.checkbox-list .custom-checkbox label:before,
.checkbox-list .custom-checkbox label:after{
  width: 1.75em;
  height: 1.75em;
  border-radius: 50% !important;
  margin-left: -1em;
  margin-top: .25em;
}
.checkbox-list .custom-checkbox label::after{
  top: 0.28;
}
@media screen and (max-width: 767px) {
  .launcher-text {
    display: none !important;
  }
}

/*Form*/
.form-container {
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border-radius: 10px;
  background: #fff;
}

/*Form Entry*/
.custom-file.multi-file {
  height: auto;
  min-height: 34px;
}

.custom-file.multi-file .custom-file-input{
  width: 0px;
}

.custom-file.multi-file .custom-file-label{
  position: relative;
  height: auto;
  min-height: 36px;
  width: 100%;
  padding-right: 80px;
  padding-top: 8px;
}

.custom-file.multi-file .custom-file-label:after {
  min-height: 32px;
  height: auto;
  display: flex;
  align-items: center;
}

/*Status*/
.status-badge {
  position: absolute !important;
  top:-7px !important;
  left:-1px !important;
  z-index: 100
}

/*Multi-Select*/
.multiselect,
.multiselect__select,
.multiselect__tags {
  min-height: 32px;
}

.multiselect__tags {
  padding: 2px 40px 0 8px;
}

.multiselect__single {
  margin-bottom: 2px;
  line-height: 25px;
}
</style>
